import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 83EE24A9-9D1A-45AA-B4CD-F75F1174F0EB
 * name format-horizontal-align-center
 * version: 1.6.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/format-horizontal-align-center.svg
 * tags
 * - Text / Content / Format 
 */
export const FormatHorizontalAlignCenterIcon = createSvgIcon(<><path d="M19,16V13H23V11H19V8L15,12L19,16M5,8V11H1V13H5V16L9,12L5,8M11,20H13V4H11V20Z" /></>, 'FormatHorizontalAlignCenterIcon');
export default FormatHorizontalAlignCenterIcon